import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { DefaultEventConfig } from 'domains/Workspaces/Settings/DefaultEventConfig'
import {
  workspaceSettingsLayoutRoute,
  workspaceSettingsRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Settings/Routing'

export const defaultEventConfigRoute = createRoute({
  getParentRoute: () => workspaceSettingsRoute,
  path: StaticRouteParameter.DEFAULT_EVENT_CONFIG,
  loader: () => ({
    crumb: t('pages:Workspace.defaultEventConfig'),
  }),
})

export const defaultEventConfigOverviewRoute = createRoute({
  getParentRoute: () => workspaceSettingsLayoutRoute,
  path: `${StaticRouteParameter.DEFAULT_EVENT_CONFIG}/`,
  component: DefaultEventConfig,
})
